import Theme from "app/constants/Theme";
import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import Icon from "react-native-vector-icons/Ionicons";

const styles = StyleSheet.create({
  main: {},
  exitButton: {
    zIndex: 100,
    position: "absolute",
    top: 20,
    right: 15,
  },
});

const ExitButton = ({ onPress, style = {}, size = 30, color = "black" }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.exitButton, style]}
      hitSlop={Theme.HITSLOP}
    >
      <Icon name="md-close" color={color} size={size} />
    </TouchableOpacity>
  );
};

export { ExitButton };
